export const modelList = [
  {
    name: "PRIEST (Spike Site Annotation)",
    path: "PRIEST",
  },
  {
    name: "Single-input Ensembl (Prediction f1 score: 0.78)",
    path: "single_input_ensemble_model_best",
  },
  {
    name: "Balanced (Prediction f1 score: 0.72)",
    path: "balanced_data_model",
  },
  {
    name: "Multi-input Ensembl (Prediction f1 score: 0.68)",
    path: "multi_input_ensemble_model",
  }
];

